<template>
<div class="chapter">
<div class="inner_page">
<p class="centerm"><a id="page_2"></a><span class="bold">By Steve R Dunn</span></p>
<p class="center"><em class="italic">The Power and the Glory: Royal Navy Fleet Reviews from Earliest Times to 2005</em>.</p>
<p class="center"><em class="italic">Battle in the Baltic: The Royal Navy and the Fight to Save Estonia and Latvia, 1918–1920</em>.</p>
<p class="center"><em class="italic">Southern Thunder: The Royal Navy and the Scandinavian Trade in World War One</em>.</p>
<p class="center"><em class="italic">Bayly’s War: The Battle for the Western Approaches in the First World War</em>.</p>
<p class="center"><em class="italic">Securing the Narrow Sea: The Dover Patrol, 1914–1918</em>.</p>
<p class="center"><em class="italic">Blockade: Cruiser warfare and the starvation of Germany in World War One</em>.</p>
<p class="center"><em class="italic">Formidable: A true story of disaster and courage</em>.</p>
<p class="center"><em class="italic">The Coward? The rise and fall of the Silver King</em>.</p>
<p class="center"><em class="italic">The Scapegoat: The life and tragedy of a fighting admiral and Churchill’s role in his death</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Frontmatter01.vue?53b9f30e